<template>
  <a-table  :columns="table.columns" :data-source="table.data" :scroll="{ x: 1000 }" :pagination="false" bordered  class="my-table"></a-table>
</template>
<script>
import { GetStatisticsLog } from "@/api/statistics";
export default {
  data() {
    return {
        id: '',
        table: {
        columns: [
          {
            key: 'name',
            dataIndex: 'name',
            title: '员工名称',
            width: 100,
          },
          {
            key: 'department_name',
            dataIndex: 'department_name',
            title: '部门名称',
            width: 100,
          },
          {
            key: 'add_contact',
            dataIndex: 'add_contact',
            title: '新增客户数',
            align: 'center',
            width: 120,
          },
          {
            key: 'loss_contact',
            dataIndex: 'loss_contact',
            title: '流失客户数',
            align: 'center',
            width: 120,
          },
          {
            key: 'count_contact',
            dataIndex: 'count_contact',
            title: '累计客户数',
            align: 'center',
            width: 120,
          },
          {
            key: 'contact_tag_ratio',
            dataIndex: 'contact_tag_ratio',
            title: '累计标签率',
            align: 'center',
            width: 120,
          }, {
            key: 'contact_mobile_ratio',
            dataIndex: 'contact_mobile_ratio',
            title: '电话备注率',
            align: 'center',
            width: 120,
          }, {
            key: 'room_num',
            dataIndex: 'room_num',
            title: '客户群数',
            align: 'center',
            width: 120,
          }, {
            key: 'add_room',
            dataIndex: 'add_room',
            title: '客户群新增数',
            align: 'center',
            width: 120,
          }, {
            key: 'room_contact',
            dataIndex: 'room_contact',
            title: '群客户总数',
            align: 'center',
            width: 120,
          }, {
            key: 'add_room_contact',
            dataIndex: 'add_room_contact',
            title: '群新增客户',
            align: 'center',
            width: 120,
          }, {
            key: 'loss_room_contact',
            dataIndex: 'loss_room_contact',
            title: '群流失客户',
            align: 'center',
            width: 120,
          }, {
            key: 'pure_add_room_contact',
            dataIndex: 'pure_add_room_contact',
            title: '群净增客户数',
            align: 'center',
            width: 120,
          }
        ],
        data: []
      },
    };
  },
  created() {
      this.id = this.$route.query.id;
      this.getDetail();
    },
    methods: {
      async getDetail() {
          const response = await GetStatisticsLog({ id: this.id });
          if (response.code === 200) {
            this.table.data= response.data
          }
      }
    },
};
</script>
<style scoped>
  .my-table {
  table-layout: fixed;
}
</style>
